import { useQuery } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"

export const useMeCamps = () => {
  return useQuery({
    queryKey: [queryKeys.ME_CAMPS],
    queryFn: () => fetchMeCamps(),
    staleTime: 3000,
  })
}

const fetchMeCamps = async () => {
  try {
    return await api2.Me.camps()
  } catch (error) {
    console.error("Error fetching Camp:", error)
    throw error
  }
}
